import React from 'react';
import { Switch, Route } from 'react-router-dom';
import asyncComponent from '../../helpers/AsyncFunc';
// import user_handler from '../../user';

class AppRouter extends React.Component {
  render() {
    const { url } = this.props;
    return (
      <Switch>
        {/* }
        <Route
          exact
          path={`${url}/Company`}
          component={asyncComponent(() => import('../Company'))}
        />
         */}
        <Route
          exact
          path={`${url}/Help`}
          component={asyncComponent(() => import('../Help'))}
        />

        <Route
          exact
          path={`${url}/Admin/Payments`}
          component={asyncComponent(() => import('../Admin/Payments'))}
        />
        <Route
          exact
          path={`${url}/`}
          component={asyncComponent(() => import('../Company'))}
        />
        {/* }
        <Route
          exact
          path={`${url}/`}
          component={asyncComponent(() => import('../Widgets/index.js'))}
        />
    */}
        <Route
          exact
          path={`${url}/welcome`}
          component={asyncComponent(() => import('../Welcome'))}
        />

        <Route
          exact
          path={`${url}/workforce`}
          component={asyncComponent(() => import('../Workforce'))}
        />
        <Route
          exact
          path={`${url}/invoice`}
          component={asyncComponent(() => import('../Invoice'))}
        />
        <Route component={asyncComponent(() =>
          import('../Page/404'))}
        />
      </Switch>
    );
  }
}

export default AppRouter;



// WEBPACK FOOTER //
// ./src/containers/App/AppRouter.js